// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__WgZ0F","sm":"Loading_sm__I3ZpK","spinner":"Loading_spinner__5wWNp","md":"Loading_md__2wmLF","spin":"Loading_spin__s3iqi"};